// @flow
export const SET_AUTO_MANAGE_HOST_TRIGGER = "SET_AUTO_MANAGE_HOST_TRIGGER";
export const SET_LOCAL_AUTO_CONNECT = "SET_LOCAL_AUTO_CONNECT";
export const SET_LOCAL_BUFFER_VALUE = "SET_LOCAL_BUFFER_VALUE";
export const SET_IS_DEVICE_CONNECTING = "SET_IS_DEVICE_CONNECTING";
export const SET_IS_PARTICIPANT_THIRD_PARTY_LISTEN = "SET_IS_PARTICIPANT_THIRD_PARTY_LISTEN";
export const SET_IS_MODERATOR_THIRD_PARTY_LISTEN = "SET_IS_MODERATOR_THIRD_PARTY_LISTEN";
export const SET_IS_EVENT_REQUESTING_LOADER = "SET_IS_EVENT_REQUESTING_LOADER";
export const SET_HOST_EVENT_RECEIVED = "SET_HOST_EVENT_RECEIVED";
export const SET_HOST_HANGUP_EVENT_RECEIVED = "SET_HOST_HANGUP_EVENT_RECEIVED";
export const SET_PREJOIN_LOADER = "SET_PREJOIN_LOADER";
export const SET_HOST_HANGUP_AUTO_CONNECT = "SET_HOST_HANGUP_AUTO_CONNECT";
export const SET_IS_WEBSOCKET_RECONNECTING = "SET_IS_WEBSOCKET_RECONNECTING";
export const SET_PREJOIN_DEVICE_MESSAGE = "SET_PREJOIN_DEVICE_MESSAGE";
export const SET_PREJOIN_AVAILABLE_DEVICES = "SET_PREJOIN_AVAILABLE_DEVICES";
export const SET_PREJOIN_STEPS_RUNNING = "SET_PREJOIN_STEPS_RUNNING";
export const SET_PREJOIN_SUBSCRIPTION_UI = "SET_PREJOIN_SUBSCRIPTION_UI";
export const SET_SHOW_RTA_JAM_INVITE_POPUP = "SET_SHOW_RTA_JAM_INVITE_POPUP"; // to show rta jam popup from participant pane;
export const SET_SHOW_RTA_JAM_EMAIL_INVITE_POPUP = "SET_SHOW_RTA_JAM_EMAIL_INVITE_POPUP";
export const SET_ALWAYS_SHOW_PRE_JOINING = "SET_ALWAYS_SHOW_PRE_JOINING";
export const SET_PREJOIN_DEVICE_PING_CALCULATE = "SET_PREJOIN_DEVICE_PING_CALCULATE";
export const SET_USER_STATIC_DEVICE_ID = "SET_USER_STATIC_DEVICE_ID";
export const SET_USER_PREJOIN_ALL_SET = "SET_USER_PREJOIN_ALL_SET";
export const SET_HIDE_WEBJAM_CONNECTED_MESSAGE = "SET_HIDE_WEBJAM_CONNECTED_MESSAGE";
export const SET_TOUR_GUIDE_TYPE = "SET_TOUR_GUIDE_TYPE";
export const SET_TOUR_GUIDE_VISIBILITY = "SET_TOUR_GUIDE_VISIBILITY";
export const SET_INVITED_USER_M_STATE = "SET_INVITED_USER_M_STATE";
export const SET_SHOW_DEVICE_HELPING_GUIDE = "SET_SHOW_DEVICE_HELPING_GUIDE";
export const SET_JAMMING_CAPABILITY_STATE = "SET_JAMMING_CAPABILITY_STATE";
export const SET_INVITED_USER_CONFIRM = "SET_INVITED_USER_CONFIRM";
export const SET_PREJOIN_SCREEN_USER_ROUTE = "SET_PREJOIN_SCREEN_USER_ROUTE";
export const SET_USER_MAKE_ROOM_PAYMENT = "SET_USER_MAKE_ROOM_PAYMENT";
export const SET_MY_DEVICES_DATA = "SET_MY_DEVICES_DATA";
export const SET_IS_MIXER_MUTE_BY_DEFAULT = "SET_IS_MIXER_MUTE_BY_DEFAULT";
export const SET_IS_JOIN_AUDIO_TO_MUTE = "SET_IS_JOIN_AUDIO_TO_MUTE";
export const SHOW_TUTORIAL_MODAL = "SHOW_TUTORIAL_MODAL";
export const SET_USER_HANGUP_STATUS = "SET_USER_HANGUP_STATUS";
export const SET_CONFIRMATION_MODAL_PROPS = "SET_CONFIRMATION_MODAL_PROPS";
export const SET_SERVER_CONNECT_REHIT = "SET_SERVER_CONNECT_REHIT";
export const SET_DISABLE_VIEW_TOGGLE = "SET_DISABLE_VIEW_TOGGLE";
export const SET_LIVE_STREAMING_STATUS = "SET_LIVE_STREAMING_STATUS";
export const SET_PREJOIN_DEVICE_CONNECT_TIME = "SET_PREJOIN_DEVICE_CONNECT_TIME";
export const SET_DEVICE_ERROR_INFO = "SET_DEVICE_ERROR_INFO"
export const SET_IS_CHINA_REGION = "SET_IS_CHINA_REGION"
export const SET_SHOW_DEVICE_PREJOIN_CONNECTION = "SET_SHOW_DEVICE_PREJOIN_CONNECTION";
export const SET_PREJOIN_CONNECTION_STAMP = "SET_PREJOIN_CONNECTION_STAMP";
export const SET_DOWNLOAD_TITLE = "SET_DOWNLOAD_TITLE";
export const SET_WHITEBOARD_OPEN_CLICKED = "SET_WHITEBOARD_OPEN_CLICKED";
export const SET_PREMEETING_SUBSCRIPTION_UI = "SET_PREMEETING_SUBSCRIPTION_UI";
export const SET_IS_NAT_TYPE = "SET_IS_NAT_TYPE";
export const SET_MANUAL_BOX_PROCESS = "SET_MANUAL_BOX_PROCESS";
export const SET_IS_DISCONNECT_LISTENED = "SET_IS_DISCONNECT_LISTENED";
export const OPEN_DIALOG_FROM_SOCIAL = "OPEN_DIALOG_FROM_SOCIAL";
export const UPDATE_LANGUAGE_FROM_SOCIAL = "UPDATE_LANGUAGE_FROM_SOCIAL";
export const SET_SOUND_CARDS_LIST = "SET_SOUND_CARDS_LIST";
export const SET_RECORDING_DETAILS = "SET_RECORDING_DETAILS";
export const SET_HIT_FIREWALL_API = "SET_HIT_FIREWALL_API";